module.exports = __webpack_public_path__ + "static/iot-0f9235125ef0e18e8ba48b2081adcaa7.png";